// Generated by `bazel run i18n`. Do not edit by hand.
import { mergeFlat } from "./merge";
import enBackendCommon from "@redotech/redo-i18n-catalog-backend-common/en";
import enCustomerPortal from "@redotech/redo-i18n-catalog-customer-portal/en";
import enCustomerPortalShared from "@redotech/redo-i18n-catalog-customer-portal-shared/en";
import enI18n from "@redotech/redo-i18n-catalog-i18n/en";
import enMerchantApp from "@redotech/redo-i18n-catalog-merchant-app/en";
import enMerchantFulfillmentApp from "@redotech/redo-i18n-catalog-merchant-fulfillment-app/en";
import enMerchantReturnsProcessingApp from "@redotech/redo-i18n-catalog-merchant-returns-processing-app/en";
import enModel from "@redotech/redo-i18n-catalog-model/en";
import enReturnApp from "@redotech/redo-i18n-catalog-return-app/en";
import enReturnCoreCommon from "@redotech/redo-i18n-catalog-return-core-common/en";
import enReturnUi from "@redotech/redo-i18n-catalog-return-ui/en";
import enTrackable from "@redotech/redo-i18n-catalog-trackable/en";
import enWeb from "@redotech/redo-i18n-catalog-web/en";

export const allCatalogs = {
  en: mergeFlat(
    enBackendCommon,
    enCustomerPortal,
    enCustomerPortalShared,
    enI18n,
    enMerchantApp,
    enMerchantFulfillmentApp,
    enMerchantReturnsProcessingApp,
    enModel,
    enReturnApp,
    enReturnCoreCommon,
    enReturnUi,
    enTrackable,
    enWeb,
  ),
  loaders: {
    da: async () =>
      mergeFlat(
        ...(await Promise.all([
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-backend-common/da").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-customer-portal/da").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-customer-portal-shared/da").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-i18n/da").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-app/da").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-fulfillment-app/da").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-returns-processing-app/da").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-model/da").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-app/da").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-core-common/da").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-ui/da").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-trackable/da").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-web/da").then(
            (m) => m.default,
          ),
        ])),
      ),
    de: async () =>
      mergeFlat(
        ...(await Promise.all([
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-backend-common/de").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-customer-portal/de").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-customer-portal-shared/de").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-i18n/de").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-app/de").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-fulfillment-app/de").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-returns-processing-app/de").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-model/de").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-app/de").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-core-common/de").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-ui/de").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-trackable/de").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-web/de").then(
            (m) => m.default,
          ),
        ])),
      ),
    es: async () =>
      mergeFlat(
        ...(await Promise.all([
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-backend-common/es").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-customer-portal/es").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-customer-portal-shared/es").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-i18n/es").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-app/es").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-fulfillment-app/es").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-returns-processing-app/es").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-model/es").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-app/es").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-core-common/es").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-ui/es").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-trackable/es").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-web/es").then(
            (m) => m.default,
          ),
        ])),
      ),
    fr: async () =>
      mergeFlat(
        ...(await Promise.all([
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-backend-common/fr").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-customer-portal/fr").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-customer-portal-shared/fr").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-i18n/fr").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-app/fr").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-fulfillment-app/fr").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-returns-processing-app/fr").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-model/fr").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-app/fr").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-core-common/fr").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-ui/fr").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-trackable/fr").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-web/fr").then(
            (m) => m.default,
          ),
        ])),
      ),
    hi: async () =>
      mergeFlat(
        ...(await Promise.all([
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-backend-common/hi").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-customer-portal/hi").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-customer-portal-shared/hi").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-i18n/hi").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-app/hi").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-fulfillment-app/hi").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-returns-processing-app/hi").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-model/hi").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-app/hi").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-core-common/hi").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-ui/hi").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-trackable/hi").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-web/hi").then(
            (m) => m.default,
          ),
        ])),
      ),
    it: async () =>
      mergeFlat(
        ...(await Promise.all([
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-backend-common/it").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-customer-portal/it").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-customer-portal-shared/it").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-i18n/it").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-app/it").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-fulfillment-app/it").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-returns-processing-app/it").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-model/it").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-app/it").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-core-common/it").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-ui/it").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-trackable/it").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-web/it").then(
            (m) => m.default,
          ),
        ])),
      ),
    nl: async () =>
      mergeFlat(
        ...(await Promise.all([
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-backend-common/nl").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-customer-portal/nl").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-customer-portal-shared/nl").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-i18n/nl").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-app/nl").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-fulfillment-app/nl").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-returns-processing-app/nl").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-model/nl").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-app/nl").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-core-common/nl").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-ui/nl").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-trackable/nl").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-web/nl").then(
            (m) => m.default,
          ),
        ])),
      ),
    pl: async () =>
      mergeFlat(
        ...(await Promise.all([
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-backend-common/pl").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-customer-portal/pl").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-customer-portal-shared/pl").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-i18n/pl").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-app/pl").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-fulfillment-app/pl").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-returns-processing-app/pl").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-model/pl").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-app/pl").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-core-common/pl").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-ui/pl").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-trackable/pl").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-web/pl").then(
            (m) => m.default,
          ),
        ])),
      ),
    pt: async () =>
      mergeFlat(
        ...(await Promise.all([
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-backend-common/pt").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-customer-portal/pt").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-customer-portal-shared/pt").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-i18n/pt").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-app/pt").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-fulfillment-app/pt").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-returns-processing-app/pt").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-model/pt").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-app/pt").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-core-common/pt").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-ui/pt").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-trackable/pt").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-web/pt").then(
            (m) => m.default,
          ),
        ])),
      ),
    ro: async () =>
      mergeFlat(
        ...(await Promise.all([
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-backend-common/ro").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-customer-portal/ro").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-customer-portal-shared/ro").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-i18n/ro").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-app/ro").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-fulfillment-app/ro").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-returns-processing-app/ro").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-model/ro").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-app/ro").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-core-common/ro").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-ui/ro").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-trackable/ro").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-web/ro").then(
            (m) => m.default,
          ),
        ])),
      ),
    se: async () =>
      mergeFlat(
        ...(await Promise.all([
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-backend-common/se").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-customer-portal/se").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-customer-portal-shared/se").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-i18n/se").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-app/se").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-fulfillment-app/se").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-returns-processing-app/se").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-model/se").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-app/se").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-core-common/se").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-ui/se").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-trackable/se").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-web/se").then(
            (m) => m.default,
          ),
        ])),
      ),
    tr: async () =>
      mergeFlat(
        ...(await Promise.all([
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-backend-common/tr").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-customer-portal/tr").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-customer-portal-shared/tr").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-i18n/tr").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-app/tr").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-fulfillment-app/tr").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-returns-processing-app/tr").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-model/tr").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-app/tr").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-core-common/tr").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-ui/tr").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-trackable/tr").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-web/tr").then(
            (m) => m.default,
          ),
        ])),
      ),
    zh: async () =>
      mergeFlat(
        ...(await Promise.all([
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-backend-common/zh").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-customer-portal/zh").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-customer-portal-shared/zh").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-i18n/zh").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-app/zh").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-fulfillment-app/zh").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-merchant-returns-processing-app/zh").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-model/zh").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-app/zh").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-core-common/zh").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-return-ui/zh").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-trackable/zh").then(
            (m) => m.default,
          ),
          // redont-allow-dynamic-import: per-locale catalog lazy-loading
          import("@redotech/redo-i18n-catalog-web/zh").then(
            (m) => m.default,
          ),
        ])),
      ),
  },
};
